'use client';
import { usePathname } from 'next/navigation';
import { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react';

interface MetaContextType {
  metaData: MetaProviderProps;
  removeData: ()=>void;
}
const MetaContext = createContext<MetaContextType>({
  metaData: {},
  removeData:()=>{}
});

export interface MetaProviderProps {
  [s: string]: string;
}
// utm_source: string;
// utm_medium: string;
// utm_campaign: string;
// utm_content: string;
// utm_term: string;

export const MetaCheckProvider = ({ children }: PropsWithChildren) => {
  const pathname = usePathname();

  const [metaData, setMetaData] = useState<MetaProviderProps>({});

  // Query is read from window.location: useSearchParams() here would turn every page into
  // client-side rendering once pages are statically generated
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.size>1) {
      const params = Object.fromEntries(searchParams.entries());
      localStorage.setItem('sourceData', JSON.stringify(params));
      setMetaData(params);
    }
  }, [pathname]);

  useEffect(() => {
    const sourceData = localStorage.getItem('sourceData');
    if (sourceData) {
      let data = JSON.parse(sourceData);
      setMetaData(data);
    }
  }, []);
  const removeData = ()=>{
    localStorage.removeItem('sourceData');
    setMetaData({});
  }

  return <MetaContext.Provider value={{ metaData, removeData }}>{children}</MetaContext.Provider>;
};

export const useMetaCheck = () => {
  const context = useContext(MetaContext);
  if (!context) {
    throw new Error('useMetaCheck must be used within a MetaCheckProvider');
  }
  return {
    metaData: context.metaData,
    removeData: context.removeData
  };
};
